import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sid = params.get("session_id");
  const { API } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sid}`);
        if (data.payment_status === "paid") setStatus("paid");
        else if (tries++ < 8) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("pending"); }
    };
    if (sid) poll();
  }, [sid]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success">
      <div className="max-w-md text-center">
        <p className="tcm-eyebrow">Payment</p>
        <h1 className="font-display text-5xl mt-3">{status === "paid" ? "Thank you" : status === "checking" ? "Confirming..." : "Almost there"}</h1>
        <hr className="tcm-gold-rule w-16 mx-auto my-6" />
        <p className="text-sm text-[color:var(--tcm-navy-70)]">
          {status === "paid" ? "Your payment is confirmed." : status === "checking" ? "Please wait a moment." : "We'll email you once it clears."}
        </p>
        <button data-testid="return-trips" onClick={() => nav("/trips")} className="tcm-btn-primary mt-8">Return to my trips</button>
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="max-w-md text-center">
        <p className="tcm-eyebrow">Payment</p>
        <h1 className="font-display text-5xl mt-3">Cancelled</h1>
        <hr className="tcm-gold-rule w-16 mx-auto my-6" />
        <p className="text-sm text-[color:var(--tcm-navy-70)]">No charge was made.</p>
        <button onClick={() => nav("/trips")} className="tcm-btn-primary mt-8">Back to my trips</button>
      </div>
    </div>
  );
}
